import { render } from "./LoaderMini.vue?vue&type=template&id=34412851"
const script = {}

import "./LoaderMini.vue?vue&type=style&index=0&id=34412851&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__